import { apiClient } from "../services/apiClient";
import { ATP_API_URL } from "../config/apiConfig";

/**
 * Submits deficiency for one or more documents.
 * POST api/Onboarding/deficiency-entity
 *
 * Body: Array of deficiency items — one per deficient document.
 *
 * @param {object} params
 * @param {number}  params.entityPrimaryId  - entityPrimaryId from entity record
 * @param {string}  params.entityId         - entityId (e.g. "AA0001")
 * @param {string}  params.entityName       - entity display name
 * @param {string}  params.emailAddress     - entity email
 * @param {string}  params.spocEmail        - SPOC email
 * @param {Array}   params.deficiencies     - [{ fileName, filePath, descriptions, deficiencyIn, gstId? }]
 */
export const deficiencyEntityAction = async ({
  entityPrimaryId = 0,
  entityId = "",
  entityName = "",
  emailAddress = "",
  spocEmail = "",
  deficiencies = [],
  defCreatedBy = "",
}) => {
  try {
    // Build array payload — one entry per deficient document
    const payload = deficiencies.map((d) => ({
      entityPrimayId: entityPrimaryId, // API typo: "Primay" not "Primary"
      gstId: d.gstId ?? 0,
      entityId: entityId,
      entityName: entityName,
      fileName: d.fileName || d.docName || "",
      filePath: d.filePath || "",
      descriptions: d.descriptions || d.reason || "",
      emailAddress: emailAddress,
      spoC_Email: spocEmail,
      deficiencyIn: d.deficiencyIn || d.fileName || d.docName || "",
      defCreatedBy: defCreatedBy,
    }));

    const response = await apiClient.post(
      ATP_API_URL.DEFICIENCY_ENTITY_NEW,
      payload,
    );

    if (response?.status === 200) {
      if (response.data?.success === false) {
        return {
          success: false,
          message: response.data.message || "Failed to submit deficiency",
        };
      }
      return {
        success: true,
        message: response.data?.message || "Deficiency submitted successfully",
      };
    }

    return { success: false, message: "Failed to submit deficiency" };
  } catch (error) {
    return {
      success: false,
      message: error.message || "Failed to submit deficiency",
    };
  }
};
